module.exports = __webpack_public_path__ + "img/jiGuang5.77eabd02.png";